import { CustomerPaymentMethod, GQL_ID } from '@@types'
import { gql, useMutation } from '@apollo/client'

interface ChooseDefaultPaymentMethodResponse {
  chooseDefaultPaymentMethod: CustomerPaymentMethod
}

interface ChooseDefaultPaymentMethodVariables {
  paymentMethodId: GQL_ID
}

export const CHOOSE_DEFAULT_PAYMENT_METHOD = gql`
  mutation ChooseDefaultPaymentMethod($paymentMethodId: ID!) {
    chooseDefaultPaymentMethod(paymentMethodId: $paymentMethodId) {
      id
      type
      last
      country
      card
      pluginId
      isDefault
    }
  }
`

export const useMutateChooseDefaultPaymentMethod = () =>
  useMutation<ChooseDefaultPaymentMethodResponse, ChooseDefaultPaymentMethodVariables>(
    CHOOSE_DEFAULT_PAYMENT_METHOD,
  )
